<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	    <h3 class="text-align-center margin-bottom-35">Loading ...</h3>
      <flash-message autoHide variant="success"></flash-message>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import axios from 'axios';
import store from '../store/store.js';

export default {
  data: function () {
    return {
    }
  },
  methods: {
  	navigate(path) {
  	  router.push(path);
  	},
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
  },
  created() {
    if(this.$route.params.token_id != '') {
      this.$store.dispatch('registerconfirm', this.$route.params.token_id)
      .then((resp) => {
          this.flash({ message: 'Please change your password ', variant: 'success' });
          this.navigate("/change_password");
       })
      .catch(err => {
        if(this.$store.state.status == 'error') {
          this.flash({ message:     this.$store.state.err_message, variant: 'danger' });
          this.navigate("/token-validation-failed");
        }
      })
    }
    else {
      this.flash({ message: 'Invalid User Crediantials', variant: 'danger' });
      this.navigate("/token-validation-failed");
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/register_confirm.vue